import React, { Component } from 'react';

import Site, {SiteModifier_,withSite} from '../utils/Site'
import Each from '../utils/Each'

import Base from '../components/BaseComponent'
import Intro from '../components/Intro'
import Item from '../components/Item'
import Content from '../components/Content'
import Grid from '../components/Grid'
import Media from '../components/Media'
import Newsletter from '../components/Newsletter'
import Button from '../components/Button'
import Image from '../components/Image'
import Filters from '../components/Filters'
import EventsList from '../components/EventsList'
import FadeIn from '../components/FadeIn'
import ContentBlocks from '../components/ContentBlocks'
import ScrollTo from '../components/ScrollTo'

import Asset from '../models/Asset'
import Entry from '../models/Entry'



class Location extends Component {

	constructor(props) {
		super(props);
	}

	componentDidMount() {

	}

	componentWillUnmount() {

	}

	/*

		RENDER

	*/

	render() {


		const {entry} = this.props;
		//console.log('entry',entry);

		const hasImage = () => {
			return entry.image ? 'hasImage' : 'noImage'
		}

		let intro;
		if(entry.image){

			intro = (
				<div className="Template-intro">
				<Item modifiers={['intro']}>

					<div className="Item-head">
						<div className="Item-title">
							<Content modifier={'yellow'}>
								<h1>{entry.title}</h1>
							</Content>
						</div>
						<div className="Item-subTitle">
							<Content>
								<h4>{entry.locationType}</h4>
							</Content>
						</div>
					</div>
					<div className="Item-media">
						<Media id={entry.image[0]} />
					</div>


				</Item>
				</div>
			)


		}else{

			intro = null;

		}

		return (
			<FadeIn>
			<ScrollTo pos={0}/>
			<div className={"Template  Template--default Template--" + hasImage()}>


					{/* Template-head */}
					<div className="Template-head">

						{intro}

					</div>
					{/* / Template-head */}

					{/* Template-body */}
					<div className="Template-body">

						<ContentBlocks blocks={entry.contentBlocks} />

					</div>
					{/* / Template-body */}


			</div>
			</FadeIn>
		);

	}
}

export default withSite(Location);



// WEBPACK FOOTER //
// ./src/js/templates/Default.js